export enum ETestIds {
  PresentationBlock = 'presentationBlock',
  Breadcrumbs = 'breadcrumbs',
  PresentationImg = 'presentationImg',
  PresentationBtn = 'presentationBtn',
  OfferCard = 'offerCard',
  OfferCardBtn = 'offerCardBtn',
  MortgageOfferValidation = 'mortgageOfferValidation',
  MortgageOfferValidationMessage = 'mortgageOfferValidationMessage',
  OfferList = 'offerList',
  OfferListContainer = 'offerListContainer',
  OfferListTitle = 'offerListTitle',
  ShowOffersButton = 'showOffersButton',
  RootMortgageWrapper = 'rootMortgageWrapper',
  ScrollUpButtonFilters = 'scrollUpButton-filters',
  ScrollUpButtonUp = 'scrollUpButton-up',
  InformationalSeo = 'informationalSeo',
  ControlsContainer = 'controlsContainer',
  SeoMarkedList = 'seoMarkedList',
  SeoRichText = 'seoRichText',
  AdvantagesBlock = 'advantagesBlock',
  ProgramsBlock = 'programsBlock',
  BankPartnersBlock = 'bankPartnersBlock',
  ProgramCard = 'programCard',
  ShortOfferCard = 'shortOfferCard',
  ShortOffersList = 'shortOffersList',
  ShortOffersEmpty = 'shortOffersEmpty',
  FamilyLoanAmountHint = 'familyLoanAmountHint',
  FamilyLoanAmountHintTooltip = 'familyLoanAmountHintTooltip',
}
